export default "__VITE_ASSET__pzoK2cUqYKhSfdVSi6cA_A__"